import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeTeamMainComponent = (function () {
    function CasePracticeTeamMainComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    CasePracticeTeamMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.typeId = params['typeId'];
            _this.multiExerciseMetaId = params['multiExerciseMetaId'];
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
        });
        this.step = 0;
        this.msgCharacter = 0;
        this.msgTimeout = null;
        this.optionWrapShow = false;
        this.optionClick = false;
        this.optionOnClick = false;
        this.optionClickTimeout = null;
        this.chatBoxTeacherShow = false;
        this.tipBoxShow = false;
        this.reviewBoxShow = false;
        this.firstOptionGuide = true;
        this.conversationHistory = [];
        this.questionsSubmit = [];
        this.answersSubmit = [];
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/multi/' + this.typeId
        }).subscribe(function (result) {
            _this.decisionTree = result;
            _this.node = 1;
            _this.subNode = 0;
            _this.currentNode = _this.decisionTree[_this.node];
            _this.currentNode.option = _this.currentNode.option.sort(function () {
                return 0.5 - Math.random();
            });
            _this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/602',
                'data': {}
            }).subscribe(function (result) {
                if (!result) {
                    _this.guideStatus = true;
                    _this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/602',
                        'data': {}
                    }).subscribe();
                }
                else {
                    _this.guideStatus = false;
                    // this.screenClick();
                }
                _this.clickable = true;
            });
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/onceino/601',
            'data': {}
        }).subscribe(function (result) {
            if (result) {
                _this.firstOptionGuide = false;
            }
        });
    };
    CasePracticeTeamMainComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeTeamMainComponent.prototype.screenClick = function () {
        var _this = this;
        /*  逻辑
        step 0: 初始化, 用户再次点击屏幕, => step 1.5
        step 1: 显示对话, 逐字输出, 再次点击 => step 1.5, 如果对话完结出现选项 => step 2
        step 1.5: 展示所有文字, 并且 => step 1
        step 2: 选择选项 => step 3, 显示我的
        step 3: 选项后重新跳入动画, 再次点击 => step 3.5
        step 3.5: 展示所有文字, 获取新内容, 再次点击 => step 1
            角色
        旁白: 没有对话框, 文字
        人物: 淡入, 人物可以多个
        点评: 滑入, 导师
        */
        if (this.clickable) {
            this.msgCharacter = 0;
            if (this.step == 0) {
                this.clickable = false;
                this.step = 1.5;
                $('#allPeople').fadeOut(0);
                $('#notice').fadeOut(0);
                $('#nextStep').fadeOut(0);
                this.setCurrentComment();
                setTimeout(function () {
                    // 显示人物
                    if (_this.currentRole.indexOf("\u0026") != -1) {
                        var currentRoles = _this.currentRole.split("\u0026"), currentRolePicWidth_1 = currentRoles.length == 2 ? "30%" : "25%";
                        currentRoles.forEach(function (c) {
                            $((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
                                "width": currentRolePicWidth_1
                            });
                            $((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
                        });
                    }
                    else {
                        $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
                    }
                    $('#nameBox').fadeTo(200, 1);
                    $('#chatBox').fadeIn(200);
                    _this.getLetterByLetter($('#chatBoxInner'));
                    $("#reviewBtn").fadeIn();
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 500);
            }
            else if (this.step == 1) {
                this.clickable = false;
                this.step = 1.5;
                // 需要优化, 不是每一次都检查是否需要fade out
                // if($('#allPeople').is(":visible")){
                //
                //    $('#allPeople').fadeOut(0);
                //
                // }
                if (this.currentRole == '点评') {
                    if (this.currentRole != this.nextRole) {
                        this.chatBoxTeacherShow = false;
                        $('#chatBoxTeacherInner').text("");
                    }
                    if (this.subNode < this.decisionTree[this.node].questions.length - 1) {
                        this.subNode++;
                        this.setCurrentComment();
                    }
                    else {
                        this.step = 2;
                        this.chatBoxTeacherShow = false;
                        $('#chatBoxTeacherInner').text("");
                    }
                }
                else if (this.currentRole == '旁白') {
                    $('#voiceOver').fadeOut(0);
                    $('#voiceOverInner').text("");
                    if (this.subNode < this.decisionTree[this.node].questions.length - 1) {
                        this.subNode++;
                        this.setCurrentComment();
                    }
                    else {
                        this.step = 2;
                    }
                }
                else {
                    if (this.currentRole != this.nextRole) {
                        // 逗号: ff0c
                        if (this.currentRole.indexOf("\u0026") != -1) {
                            var currentRoles = _this.currentRole.split("\u0026");
                            // 移出current roles
                            currentRoles.forEach(function (c) {
                                $((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
                                    "width": 0
                                });
                                $((_this.getDomIdByName(c.trim()) + 'Multi')).fadeOut(0);
                            });
                        }
                        else {
                            $(this.getDomIdByName(this.currentRole)).fadeOut(0);
                        }
                        $('#nameBoxInner').fadeOut(0);
                        $('#nameBoxInner').text("");
                    }
                    $('#chatBoxInner').fadeOut(0);
                    $('#chatBoxInner').text("");
                    if (this.subNode < this.decisionTree[this.node].questions.length - 1) {
                        this.subNode++;
                        this.setCurrentComment();
                    }
                    else {
                        this.step = 2;
                    }
                    if (this.currentRole == '点评' || this.currentRole == '旁白' || this.step == 2) {
                        $('#nameBox').fadeTo(200, 0);
                        $('#chatBox').fadeOut(0);
                    }
                }
                //对话时要先退出
                $('#nameBox').fadeTo(200, 0);
                $('#chatBox').fadeOut(200);
                // 过500ms后进行
                setTimeout(function () {
                    if (_this.step == 1.5) {
                        if (_this.currentRole == '点评') {
                            if (_this.oldRole != '点评') {
                                _this.chatBoxTeacherShow = true;
                            }
                            setTimeout(function () {
                                $('#chatBoxTeacherInner').show();
                                _this.getLetterByLetter($('#chatBoxTeacherInner'));
                            }, 200);
                        }
                        else if (_this.currentRole == '旁白') {
                            $('#voiceOver').fadeIn(200);
                            _this.getLetterByLetter($('#voiceOverInner'));
                        }
                        else {
                            // console.log(_this.oldRole);
                            // console.log(_this.currentRole);
                            if (_this.oldRole != _this.currentRole) {
                                if (_this.currentRole.indexOf("\u0026") != -1) {
                                    var currentRoles = _this.currentRole.split("\u0026"), currentRolePicWidth_2 = currentRoles.length == 2 ? "30%" : "25%";
                                    currentRoles.forEach(function (c) {
                                        $((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
                                            "width": currentRolePicWidth_2
                                        });
                                        $((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
                                    });
                                }
                                else {
                                    $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
                                }
                                $('#nameBox').fadeTo(200, 1);
                                $('#nameBoxInner').fadeIn(200);
                                _this.showName($('#nameBoxInner'));
                            }
                            $('#nameBox').fadeTo(200, 1);
                            $('#chatBox').fadeIn(200);
                            $('#chatBoxInner').fadeIn(200);
                            _this.getLetterByLetter($('#chatBoxInner'));
                        }
                        // 允许点击
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 1000);
                    }
                    else if (_this.step == 2) {
                        $('#nameBox').fadeTo(200, 0);
                        $('#chatBox').fadeOut(0);
                        $('#chatBoxInner').hide();
                        $('#nameBoxInner').hide();
                        $('#nameBoxInner').text("");
                        $('#chatBoxInner').text("");
                        if (_this.currentNode.option.length > 0) {
                            if (_this.firstOptionGuide) {
                                $('#shade2').fadeIn();
                                _this.firstOptionGuide = false;
                            }
                            _this.optionWrapShow = true;
                            _this.clickable = false;
                        }
                        else {
                            // $('#tipBox').fadeIn(200);
                            $('#allPeople').fadeIn(200);
                            _this.tipBoxShow = true;
                            _this.apiService.ajax({
                                'type': 'post',
                                'url': '/api/multi',
                                'data': {
                                    'multi_type_id': _this.typeId,
                                    'questions': _this.questionsSubmit,
                                    'answers': _this.answersSubmit
                                }
                            }).subscribe(function (result) { });
                        }
                    } // end of step == 2
                }, 500); // end of setTimeout
            }
            else if (this.step == 1.5) {
                this.clickable = false;
                this.step = 1;
                if (this.currentRole == '点评') {
                    this.showFullText($('#chatBoxTeacherInner'));
                }
                else if (this.currentRole == '旁白') {
                    this.showFullText($('#voiceOverInner'));
                }
                else {
                    this.showFullText($('#chatBoxInner'));
                }
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }
            else if (this.step == 3) {
                this.clickable = false;
                this.step = 3.5;
                if (this.nextRole == '点评' || this.nextRole == '旁白') {
                    $('#nameBoxInner').fadeOut(0);
                    $('#nameBoxInner').text("");
                    $('#nameBox').fadeTo(200, 0);
                    $('#chatBox').fadeOut(0);
                    $('#allPeople').fadeOut(0);
                }
                $('#chatBoxInner').fadeOut(0);
                $('#chatBoxInner').text("");
                $('#chatBoxTeacherInner').text("");
                $('#voiceOverInner').text("");
                setTimeout(function () {
                    _this.setCurrentComment();
                    if (_this.currentRole == '点评') {
                        _this.chatBoxTeacherShow = true;
                        setTimeout(function () {
                            $('#chatBoxTeacherInner').show();
                            _this.getLetterByLetter($('#chatBoxTeacherInner'));
                        }, 200);
                    }
                    else if (_this.currentRole == '旁白') {
                        $('#voiceOver').fadeIn(200);
                        _this.getLetterByLetter($('#voiceOverInner'));
                    }
                    else {
                        if (_this.currentRole != _this.oldRole) {
                            // 如果有多个角色, 分开显示
                            if (_this.currentRole.indexOf("\u0026") != -1) {
                                var currentRoles = _this.currentRole.split("\u0026"), currentRolePicWidth_3 = currentRoles.length == 2 ? "30%" : "25%";
                                currentRoles.forEach(function (c) {
                                    $((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
                                        "width": currentRolePicWidth_3
                                    });
                                    $((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
                                });
                            }
                            else {
                                $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
                            }
                            $('#nameBoxInner').fadeIn(200);
                        }
                        $('#chatBoxInner').fadeIn(200);
                        _this.getLetterByLetter($('#chatBoxInner'));
                    }
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 300); // end of setTimeout
            }
            else if (this.step == 3.5) {
                this.clickable = false;
                this.step = 1;
                if (this.currentRole == '点评') {
                    this.showFullText($('#chatBoxTeacherInner'));
                }
                else if (this.currentRole == '旁白') {
                    this.showFullText($('#voiceOverInner'));
                }
                else {
                    this.showFullText($('#chatBoxInner'));
                }
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000); // end of set timeout
            } // end of step == 3.5
        } // end of if clickable
    }; // end of screenClick
    CasePracticeTeamMainComponent.prototype.setCurrentComment = function () {
        this.oldRole = this.currentRole;
        if (this.subNode < this.currentNode.questions.length - 1) {
            this.nextRole = this.currentNode.questions[this.subNode + 1].multi_role;
        }
        else {
            this.nextRole = "option";
        }
        this.conversation = this.currentNode.questions[this.subNode];
        this.currentRole = this.conversation.multi_role;
        this.currentComment = this.conversation.multi_description_comment;
        var temp = this.currentRole;
        if (temp == '点评') {
            temp = '导师点评';
        }
        this.conversationHistory.push({
            'role': temp,
            'comment': this.currentComment
        });
    }; // end of setCurrentComment
    CasePracticeTeamMainComponent.prototype.onOptionMouseDown = function (i, event) {
        if (this.optionClick == true || this.optionOnClick == true) {
            return false;
        }
        var _this = this, pressing = $(event.target).children('.pressing'), // 选项背景进度div
        pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
        pressingWidth = $(event.target).width(), // 选项宽度
        pressingHeight = $(event.target).height(), // 选项高度
        pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
        pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
        // 按选项少于0.45s, 则不响应
        this.optionClick = false;
        this.optionOnClick = true;
        // 设置选项动画参数
        pressingOption.width(pressingWidth);
        pressingOption.height(pressingHeight);
        pressing.width(0);
        pressing.height(pressingOuterHeight),
            pressing.show();
        pressing.offset({
            top: pressingOffset.top,
            left: pressingOffset.left
        });
        // 选项背景动画
        pressing.animate({
            width: $(event.target)[0].clientWidth
        }, this.type ? 300 : 500, 'linear');
        // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
        this.optionClickTimeout = setTimeout(function () {
            // 长按响应
            _this.optionClick = true;
            _this.nextNode = _this.currentNode.option[i].multi_option_next_question_id;
            _this.questionsSubmit.push(_this.currentNode.option[i].multi_question_id);
            _this.answersSubmit.push(_this.currentNode.option[i].multi_option_id);
            // 隐藏背景色
            pressing.animate({
                width: 0
            }, 1);
            pressing.hide();
            // 进入选中按钮动画
            $(event.target).addClass('optionLongPress');
            // 按键之后的动画
            $(event.target).find('.loading').fadeIn(200);
            // 隐藏文字
            _this.conversationHistory.push({
                'role': '我的选择',
                'comment': _this.currentNode.option[i].multi_option_comment
            });
            _this.currentNode.option[i].multi_option_comment = "";
            // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
            $('.option').not($(event.target)).fadeOut(2500);
            // 保持选中按钮动画2s, 跳转动画
            setTimeout(function () {
                // 移出按钮动画
                $(event.target).removeClass('optionLongPress');
                // 移出选项
                _this.optionWrapShow = false;
                // 移入人物场景对话
                $('#allPeople').fadeIn(200);
                $('#nameBox').fadeTo(200, 1);
                $('#chatBox').fadeIn(200);
                $('#nameBoxInner').fadeIn(200);
                $('#chatBoxInner').fadeIn(200);
                _this.step = 1.5;
                _this.optionClick = false;
                _this.subNode = 0;
                _this.node = _this.nextNode;
                _this.currentNode = _this.decisionTree[_this.node];
                _this.currentNode.option = _this.currentNode.option.sort(function () {
                    return 0.5 - Math.random();
                });
                _this.setCurrentComment();
                _this.showName($('#nameBoxInner'));
                _this.getLetterByLetter($('#chatBoxInner'));
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 2000); // end of second setTimeout
        }, 450); // end of first setTimeout
    }; //end of onOptionMouseDown
    CasePracticeTeamMainComponent.prototype.onOptionMouseUp = function (event) {
        var _this = this;
        this.optionOnClick = true;
        setTimeout(function () {
            _this.optionOnClick = false;
        }, 300);
        // 如果已经触发按钮事件, 忽略放松按钮行为
        if (this.optionClick == true) {
            return true;
        }
        var pressing = $(event.target).children('.pressing');
        // 调整宽度为0
        setTimeout(function () {
            clearTimeout(_this.optionClickTimeout);
            pressing.stop().animate({
                width: 0
            }, 300, 'linear');
        }, this.type ? 300 : 0);
    }; // end of onOptionMouseUp
    CasePracticeTeamMainComponent.prototype.goBack = function () {
        var link = ['case-practice-team-begin', this.multiExerciseMetaId, this.learningPathId, this.practiceMetaId];
        var type = null;
        this.route.queryParams.subscribe(function (queryParams) {
            type = queryParams['type'];
        });
        if (type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    };
    CasePracticeTeamMainComponent.prototype.getDomIdByName = function (name) {
        if (name == '季宁') {
            return '#blackPeople';
        }
        else if (name == '王立娜') {
            return '#purplePeople';
        }
        else if (name == '秦飞') {
            return '#bluePeople';
        }
        else if (name == '方科科') {
            return '#redPeople';
        }
        else if (name == '我' || name == '众人') {
            return '#allPeople';
        }
    }; // end of getDomIdByName
    CasePracticeTeamMainComponent.prototype.getLetterByLetter = function (container) {
        var _this = this;
        this.msgTimeout = setTimeout(function () {
            _this.msgCharacter++;
            var type = _this.currentComment.substring(0, _this.msgCharacter);
            container.text(type);
            _this.getLetterByLetter(container);
            if (_this.msgCharacter == _this.currentComment.length) {
                _this.step = 1;
                clearTimeout(_this.msgTimeout);
            }
        }, 30); // end of setTimeout
    }; // end of getLetterByLetter
    CasePracticeTeamMainComponent.prototype.showFullText = function (container) {
        clearTimeout(this.msgTimeout);
        container.text(this.currentComment);
    }; // end of showFullText
    CasePracticeTeamMainComponent.prototype.showName = function (container) {
        container.text(this.currentRole);
    }; // end of showName
    CasePracticeTeamMainComponent.prototype.reviewConversation = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeIn(50);
        // $('#reviewBox').fadeIn();
        this.reviewBoxShow = true;
        // console.log(this.reviewBoxShow);
        $('#closeBtn').fadeIn();
        this.clickable = false;
    };
    CasePracticeTeamMainComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut();
        // $('#reviewBox').fadeOut();
        this.reviewBoxShow = false;
        $('#closeBtn').fadeOut();
        // 恢复点击功能
        this.clickable = true;
    };
    CasePracticeTeamMainComponent.prototype.pressTipOut = function () {
        $('#shade2').fadeOut();
        $('#pressTipPic1').fadeOut();
        $('#pressTipText').fadeOut();
        $('#pressTipButton').fadeOut();
        this.apiService.ajax({
            'type': 'post',
            'url': '/sr/onceino/601',
            'data': {}
        }).subscribe(function (result) {
        });
    };
    return CasePracticeTeamMainComponent;
}());
export { CasePracticeTeamMainComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team-main/case-practice-team-main.component.ts.pre-build-optimizer.js